import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import NotFound from '../../../Images/notFound.png';
import { Paper, makeStyles, TableBody, TableRow, TableCell, CircularProgress, Switch } from '@material-ui/core';
import useTable from '../../useTable';
import SearchIcon from '@material-ui/icons/Search';
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import CustomAlert from '../../CustomAlert';
import { Helmet } from 'react-helmet';
import { getTodaySupplyOrderDocument, updateSupplyOrderDocument } from '../../../Backend/firebase/supply-order';
import { parseDate } from '../../Models/CommonFunc';
import { useHistory } from 'react-router-dom';
import ChemistDropdown from './ChemistDropdown';


const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'initial',
        flexDirection: 'column',
        width: '100%'
    },
    fixedHeight: {
        height: '100%',
    },
}));

const headCells = [
    // { id: 'ChemistInfo', label: 'Chemist Info', disableSorting: false, isCopyEnable: true },
    { id: 'ProductName', label: 'Product Name', disableSorting: true, isCopyEnable: true },
    { id: 'MedicineType', label: 'Medicine Type', disableSorting: false, isCopyEnable: true },
    { id: 'ProductQuantity', label: 'Quantity', disableSorting: true, isCopyEnable: true },
    { id: 'IsAvailable', label: 'Is Available', disableSorting: true },
]

function WholesalerOrderHistory() {
    const classes = useStyles();
    const history = useHistory()
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const { userData } = CheckUserProvider();
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [searchChange, setSearchChange] = useState(false);
    const [pageAfterSearch, setPageAfterSearch] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } = useTable(records, headCells, filterFn,
        searchChange, pageAfterSearch);
    const [openNotify, setOpenNotify] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [selectedChemist, setSelectedChemist] = useState("");

    useEffect(async () => {
        var isLogin = localStorage.getItem(process.env.REACT_APP_EMPLOYER_ISLOGIN) || false;
        if (!isLogin || isLogin == "false") {
           history.push("/activity/Login");
        }
    },[])

    const handleSearch = (e) => {
        let target = e.target;
        if (target.value === '') {
            setSearchChange(false);
            setPageAfterSearch(false);
        }
        else {
            setSearchChange(true);
            setPageAfterSearch(true);
        }
        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items
                } else {
                    return items?.filter(x => x?.ProductName?.toLowerCase()?.includes(target.value.toLowerCase()) ||
                                                x?.MedicineType?.toLowerCase()?.includes(target.value.toLowerCase()) || 
                                                x?.ChemistInfo?.toLowerCase()?.includes(target.value.toLowerCase()));
                }
            }
        });
    };

    useEffect(async () => {
        if (userData) {
            setIsLoading(true);
            try {
                const getSupplyOrder = await getTodaySupplyOrderDocument();
                let todaysOrder = getSupplyOrder.filter(x => parseDate(x.SupplyOrderPostedDateTime).includes(parseDate(new Date())))
                setRecords(todaysOrder);
                setIsLoading(false);
            } catch(error) {
                console.log("Error Occur in Get Order", error)
                setIsLoading(false);
            }
        }
    }, [userData]);

    const handleToggle = async (item) => {
        const newAvailability = !item.IsAvailable;
        const updatedRecords = records.map(record => 
          record._id === item._id ? { ...record, IsAvailable: newAvailability } : record
        );
        setRecords(updatedRecords);
        try {
            var supplyStock = {
                ...item,
                IsAvailable: !records.find(record => record._id === item._id).IsAvailable 
            };

            var stockManagmentDetails = updateSupplyOrderDocument(supplyStock);
            if (stockManagmentDetails) {
                console.info("ORDER UPDATE IN SUPPLY MANAGEMNT SUCCESSFULLY ==>");
            } else {
                console.error("ERROR OCCURS IN SUPPLY UPDATE MANAGEMNT ELSE BLOCK ==>");
            }
        } catch (error) {
          console.error('Error updating availability:', error);
          const revertedRecords = records.map(record => 
            record._id === item._id ? { ...record, IsAvailable: !newAvailability } : record
          );
          setRecords(revertedRecords);
        }
    };

    const handleChemistFilters = (value) => {
        console.log('value', value)
        setFilterFn({
            fn: items => {
                if (value === "") {
                    return items
                } else {
                    return items?.filter(x => x?.ChemistInfo?.toLowerCase()?.includes(value.toLowerCase()));
                }
            }
        });
    }
    

    return (
        <>
            {!userData || isLoading ?
                (<div className="row">
                    <div className="col-md-12 text-center p-4">
                        <CircularProgress />
                    </div>
                </div>) :
                (<div className="allProductsAndSales">
                    <Paper className={fixedHeightPaper}>
                        <Helmet>
                            <meta name="description" content="Find Order you have posted till now." />
                            <title>Order | Kaipsool Pharmatech</title>
                        </Helmet>
                        <div className="row d-flex justify-content-center align-items-center">
                            <div className="col-md-8">
                                <h5>Today's Order List</h5>
                            </div>
                            <div className="col-md-4">
                                <div className="d-flex justify-content-center w-100 align-items-center allProductsTable__searchBox">
                                    <SearchIcon className="mr-2" />
                                    <input type="text" placeholder="Search Order..." className="border-0"
                                        onChange={handleSearch} />
                                </div>
                            </div>
                            {/* <div className="col-md-12">
                                <ChemistDropdown 
                                    data={records} 
                                    handleFilters={handleChemistFilters} 
                                    selectedChemist={selectedChemist} 
                                    setSelectedChemist={setSelectedChemist} 
                                />
                            </div> */}
                            {records.length > 0 ? <div className="row col-md-12 supply-order-table">
                                <TblContainer>
                                    <TblHead />
                                    <TableBody>
                                        {
                                            recordsAfterPagingAndSorting().map(item => (
                                                <TableRow key={item.id}>
                                                    {/* <TableCell>{item.ChemistInfo ? item.ChemistInfo : "NA"}</TableCell> */}
                                                    <TableCell>{item.ProductName ? item.ProductName : "NA"}</TableCell>
                                                    <TableCell>{item.MedicineType ? item.MedicineType : "Generic"}</TableCell>
                                                    <TableCell>{item.ProductQuantity ? item.ProductQuantity : "NA"}</TableCell>
                                                    <TableCell>
                                                        {item?.IsAvailable}
                                                        <Switch
                                                            checked={item.IsAvailable}
                                                            onChange={() => handleToggle(item)}
                                                            color="primary"
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        }
                                    </TableBody>
                                </TblContainer>
                                <TblPagination />
                            </div> : <div className="row col-md-12 mt-3 text-center">
                                <img src={NotFound} className="notFound" />
                                <h4>No Order Record Found!</h4>
                            </div>}
                        </div>
                    </Paper>
                </div>)
            }
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType || 'error'}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default WholesalerOrderHistory
